// src/components/sections/LocationSection/LocationSection.jsx

import React from 'react';
import './LocationSection.css';

const LocationSection = () => {

  const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4543.311799458926!2d-45.05667!3d-22.116301999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cb4b94c864b1f1%3A0x46c434ad5aae055b!2sHotel%20Alzira%20Imperial!5e1!3m2!1spt-BR!2sbr!4v1762718645499!5m2!1spt-BR!2sbr";

  return (
    <section id="localizacao" className="location-section">
      <div className="map-container">
        <iframe
          title="Localização do Hotel Alzira Imperial"
          src={mapUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default LocationSection;
